import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem } from '../models/rich-data.model';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  constructor(private translate: TranslatePipe) { }

  transform(value: MenuItem[], query: string): MenuItem[] {
console.log('value', value);
console.log('query', query);

    if (!query) {
      return value;
    }

    return value.filter(item => {
      return this.translate.transform(item.name).toLowerCase().includes(query.toLowerCase());
    });

  }


}
